import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderService } from '@app/services/order/order.service';
import { ToastService } from '@app/storybook/services/toast/toast.service';
import { Order } from '@pdqdev/pdq-shared/dist/entities';
import { ExportOptionType, ExportOptionTypeLabel } from '@utils/export-utils';
@Component({
  selector: 'app-downloadorderdialog',
  templateUrl: './downloadorderdialog.component.html',
  styleUrls: ['./downloadorderdialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class DownloadorderdialogComponent implements OnInit {
  exportMethods = [
    {
      value: 'csv',
      text: 'CSV',
    },
  ];
  loading = false;
  selectedValue = 'csv';
  selectedRowsIds = [];
  option: ExportOptionType;
  selectedOrders: Order[];
  optionDisplay: string;
  constructor(
    public dialogRef: MatDialogRef<DownloadorderdialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      option: ExportOptionType;
      selectedOrders: Order[];
    },
    private toastService: ToastService,
    private orderService: OrderService,
  ) {
    this.option = data.option;
    this.selectedOrders = data.selectedOrders;
    this.optionDisplay = ExportOptionTypeLabel[this.option];
  }

  ngOnInit(): void {
    for (const key in this.selectedOrders) {
      if (!this.selectedOrders.hasOwnProperty(key)) continue;
      const obj = this.selectedOrders[key];
      for (const prop in obj) {
        if (!obj.hasOwnProperty(prop)) continue;
        if (prop == 'id') {
          this.selectedRowsIds.push(obj[prop]);
        }
      }
    }
  }

  onClickExport(): void {
    switch (this.option) {
      case ExportOptionType.GENERAL_REPORT:
        this.downloadGeneralReport();
        break;

      case ExportOptionType.PICK_LIST:
        this.downloadPicklist();
        break;
    }
  }

  async downloadPicklist() {
    this.loading = true;
    switch (this.selectedValue) {
      case 'csv':
        this.orderService.exportPicklistToCSV(this.selectedRowsIds).subscribe({
          next: (result) => {
            this.download('picklist.csv', result);
          },
          error: () => {
            this.toastService.showToast({
              message: 'Error exporting picklist',
              mode: 'danger',
            });
          },
          complete: () => {
            this.loading = false;
            this.dialogRef.close();
          },
        });

        break;
    }
  }

  downloadGeneralReport(): void {
    this.loading = true;
    switch (this.selectedValue) {
      case 'csv':
        this.orderService
          .exportOrdersToCSV(this.selectedRowsIds)
          .then((result) => {
            this.download('selectedOrders.csv', result);
            this.loading = false;
          })
          .catch(() => {
            this.toastService.showToast({
              message: 'Error exporting general report',
              mode: 'danger',
            });
          })
          .finally(() => {
            this.loading = false;
            this.dialogRef.close();
          });
        break;
    }
  }

  download(filename, text): void {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }
}
